import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollVariable_DTO  {
    _originalTypeClassName = "zERP.BO.PayrollVariable_DTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollVariable_DTO.translate = translateService;
}
this.Id = null;
this.Name = null;
this.Code = null;
this.Description = null;
this.Type = null;
this.DefaultValue = null;
this.DefinitionLevel = null;
this.GetValueFromData = false;
this.TrackHistoricData = false;
this.DatasourceEntityName = null;
this.DatasourceFieldName = null;
this.Code_ = null;
this.report = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Code:any;
Description:any;
Type:any;
DefaultValue:any;
DefinitionLevel:any;
GetValueFromData:any;
TrackHistoricData:any;
DatasourceEntityName:any;
DatasourceFieldName:any;
Code_:any;
report:any;


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}